import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export const formatQuantity = value => Number(value || 0).toLocaleString('fr-FR', { maximumFractionDigits: 3 });
export const formatSalesAmount = value => `${Number(value || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH`;
export const reportDate = value => value ? value.split('-').reverse().join('/') : '';
export const averageUnitPrice = article => {
    const quantity = Number(article.quantity);
    const amount = Number(article.amount);
    return Number.isFinite(quantity) && quantity !== 0 && Number.isFinite(amount) ? amount / quantity : null;
};

export const quantitiesByUnit = articles => Object.entries(articles.reduce((totals, article) => {
    const unit = article.unit || 'unité';
    totals[unit] = (totals[unit] || 0) + Number(article.quantity || 0);
    return totals;
}, {})).map(([unit, quantity]) => `${formatQuantity(quantity)} ${unit}`).join(' · ');

export const buildArticleSalesPdf = (report, { company, clientLabel, query }) => {
    const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
    const width = doc.internal.pageSize.getWidth();
    const height = doc.internal.pageSize.getHeight();
    const clean = value => String(value ?? '').replace(/[\u00a0\u202f]/g, ' ');
    const lines = [
        company?.name || '',
        `Du ${reportDate(report.dateDebut)} au ${reportDate(report.dateFin)}`,
        `Client : ${clientLabel || 'Tous les clients'}`,
        query ? `Article recherché : ${query}` : '',
    ].filter(Boolean).flatMap(line => doc.splitTextToSize(clean(line), width - 24));
    const headerEnd = 22 + lines.length * 4;
    const startY = headerEnd + 10;
    doc.setFontSize(9);
    doc.text(clean(`${report.articles.length} articles vendus | Total ventes : ${formatSalesAmount(report.totalAmount)}`), 12, headerEnd + 4);
    autoTable(doc, {
        startY,
        margin: { top: headerEnd + 2, bottom: 20, left: 12, right: 12 },
        head: [['Article / code-barres', 'Quantité', 'Prix unitaire', 'Montant des ventes']],
        body: report.articles.map(article => {
            const price = averageUnitPrice(article);
            return [clean([article.designation, article.barcode].filter(Boolean).join('\n')),
                clean(`${formatQuantity(article.quantity)} ${article.unit || 'unité'}`),
                price === null ? '-' : clean(formatSalesAmount(price)), clean(formatSalesAmount(article.amount))];
        }),
        foot: [['Total ventes', '', '', clean(formatSalesAmount(report.totalAmount))]],
        showFoot: 'lastPage',
        theme: 'striped',
        styles: { fontSize: 9, cellPadding: 1.6, overflow: 'linebreak', valign: 'middle' },
        headStyles: { fillColor: [35, 77, 110] },
        footStyles: { fillColor: [235, 240, 245], textColor: [20, 20, 20] },
        columnStyles: { 0: { cellWidth: width - 119 }, 1: { cellWidth: 29, halign: 'right' }, 2: { cellWidth: 32, halign: 'right' }, 3: { cellWidth: 34, halign: 'right' } },
        didDrawPage: () => {
            doc.setFont('helvetica', 'bold'); doc.setFontSize(14); doc.setTextColor(25, 45, 65);
            doc.text('Ventes par article', 12, 14);
            doc.setFont('helvetica', 'normal'); doc.setFontSize(9);
            doc.text(lines, 12, 22, { lineHeightFactor: 1.25 });
        },
    });
    const pages = doc.internal.getNumberOfPages();
    for (let page = 1; page <= pages; page += 1) {
        doc.setPage(page); doc.setFont('helvetica', 'normal'); doc.setFontSize(7.5); doc.setTextColor(90);
        doc.text(doc.splitTextToSize('Ventes livrées, retours non déduits. Prix unitaire = montant / quantité.', width - 60), 12, height - 13);
        doc.text(`Page ${page} / ${pages}`, width - 12, height - 9, { align: 'right' });
    }
    return doc;
};
